import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconRectangleCollapse.tsx
const IconRectangleCollapse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M2 8a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2 0v11h13V8z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M7 3a2 2 0 0 0-2 2v1h2V5h13v11h-1v2h1a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
		})
	]
});
var IconRectangleCollapse_default = forwardRef(IconRectangleCollapse);
//#endregion
export { IconRectangleCollapse_default as default };
